module.exports = __webpack_public_path__ + "static/img/53-2.c956f22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/53-2.jpg
// module id = lJII
// module chunks = 0